import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
import { normalizeImgSrc } from '../utils';
import { extractHeadingHtml, extractDescriptionHtml } from '../helpers/extract-suggestion';

export const buildReviewGrid02 = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;
  const avatarFallback = `https://cdn.latteprint.com/latte/2025-08-22/1755856692831-80.jpg`;
  const headingContent = suggestionFields.content?.heading;
  const subheadingContent = suggestionFields.content?.subheading;
  const titleReview = `${headingContent ? `<h2>${headingContent}</h2>` : ''} ${
    subheadingContent ? `<p>${subheadingContent}</p>` : ''
  }`;

  const bodyReview = suggestionFields.content?.cards
    ?.filter(b => b.blocks.findIndex(i => i.block_type === 'testimonial') >= 0)
    ?.map(i => {
      const testimonial = i.blocks?.find(t => t.block_type === 'testimonial');
      if (!testimonial) return null;
      const avatar = normalizeImgSrc(testimonial?.testimonial_data?.avatar_url) || avatarFallback;
      const name = testimonial?.testimonial_data?.author || 'Anonymous';
      const content =
        testimonial?.testimonial_data?.content ||
        "Perfect !! Keeps nappies, snacks and medicines together. I'm not digging through the bag every 5 minutes anymore";
      const rating = 5;
      return {
        avatar,
        name,
        content,
        rating,
      };
    })
    .filter(Boolean);

  const fieldUpdate = {
    title: 'Review Grid 02',
    enableAnchor: false,
    'title-review': titleReview,
    'body-review': bodyReview,
  };
  if (!bodyReview?.length) {
    fieldUpdate['body-review'] = [
      {
        avatar: avatarFallback,
        name: 'Anonymous',
        content:
          "Perfect !! Keeps nappies, snacks and medicines together. I'm not digging through the bag every 5 minutes anymore",
        rating: 5,
      },
      {
        avatar: avatarFallback,
        name: 'Anonymous',
        content:
          "Perfect !! Keeps nappies, snacks and medicines together. I'm not digging through the bag every 5 minutes anymore",
        rating: 5,
      },
      {
        avatar: avatarFallback,
        name: 'Anonymous',
        content:
          "Perfect !! Keeps nappies, snacks and medicines together. I'm not digging through the bag every 5 minutes anymore",
        rating: 5,
      },
    ];
  }

  return {
    ...newSection,
    html: updateHtmlFromData.sectionReviewGrid02(newSection.html, fieldUpdate),
  };
};

// Videoable
export const buildCardMediaSlider03 = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const headingContent = suggestionFields.content?.heading;
  const subheadingContent = suggestionFields.content?.subheading;

  const htmlHeading = `${headingContent ? `<h2>${headingContent}</h2>` : ''} ${
    subheadingContent ? `<p>${subheadingContent}</p>` : ''
  }`;

  const listItem = suggestionFields.content?.cards
    ?.filter(b => b.blocks.findIndex(i => i.block_type === 'media') >= 0)
    ?.map(i => {
      const media = i.blocks?.find(t => t.block_type === 'media');
      if (!media) return null;
      const type = media.media?.media_type;
      const mediaSrc = normalizeImgSrc(media.media?.url);
      const heading = extractHeadingHtml(i.blocks);
      const content = extractDescriptionHtml(i.blocks);
      return {
        type,
        image: type === 'image' ? mediaSrc : null,
        video: type === 'video' ? mediaSrc : null,
        content: type === 'image' ? `${heading}\n${content}` : '',
      };
    })
    .filter(Boolean);

  const fieldUpdate = {
    // title: 'Card Media Slider 03',
    enableAnchor: false,
    header: {
      show: headingContent || subheadingContent,
      content: htmlHeading,
    },
    'card-item-background-color': '#ffffff',
    listItem: listItem,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionCardMediaSlider03(newSection.html, fieldUpdate),
  };
};

export const buildCardSliderYuri = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const headingContent = suggestionFields.content?.heading;
  const subheadingContent = suggestionFields.content?.subheading;

  const htmlHeading = `${headingContent ? `<h2>${headingContent}</h2>` : ''} ${
    subheadingContent ? `<p>${subheadingContent}</p>` : ''
  }`;

  const listItem = suggestionFields.content?.cards
    ?.filter(b => b.blocks.findIndex(i => i.block_type === 'media') >= 0)
    ?.map(i => {
      const media = i.blocks?.find(t => t.block_type === 'media');
      if (!media) return null;
      const mediaSrc = normalizeImgSrc(media.media?.url);
      const heading = extractHeadingHtml(i.blocks);
      const content = extractDescriptionHtml(i.blocks);
      return {
        image: mediaSrc,
        content: `${heading}\n${content}`,
      };
    })
    .filter(Boolean);

  const fieldUpdate = {
    enableAnchor: false,
    background: '#ebebeb',
    textColor: '#000000',
    showTitle: headingContent || subheadingContent,
    titleCard: htmlHeading,
    listShow: true,
    listItem: listItem,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionCardSliderYuri(newSection.html, fieldUpdate),
  };
};

export const buildMarqueeShopzovya = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const listItem = suggestionFields.content?.cards
    ?.filter(b => b.blocks.findIndex(i => i.block_type === 'media') >= 0)
    ?.map(i => {
      const media = i.blocks?.find(t => t.block_type === 'media');
      let mediaSrc = normalizeImgSrc(media.media?.url);
      let heading = extractHeadingHtml(i.blocks, 'span');
      let content = extractDescriptionHtml(i.blocks, 'span');
      const testimonial = i.blocks?.find(t => t.block_type === 'testimonial');
      if (testimonial) {
        mediaSrc = normalizeImgSrc(testimonial?.testimonial_data?.avatar_url) || '';
        heading = testimonial?.testimonial_data?.author || 'Anonymous';
        content =
          testimonial?.testimonial_data?.content ||
          "Perfect !! Keeps nappies, snacks and medicines together. I'm not digging through the bag every 5 minutes anymore";
      }
      if (!media) return null;

      return {
        avatar: mediaSrc,
        ratingPoint: 5,
        textRating: `${heading}\n${content}`,
      };
    })
    .filter(Boolean);
  const fieldUpdate = {
    rows: [
      {
        items: listItem,
      },
    ],
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionMarqueeShopzovya(newSection.html, fieldUpdate),
  };
};
